import { graphql, HttpResponse } from 'msw'
import { type InvestmentInstrument } from '../../../models'

export const investmentInstrumentMock: InvestmentInstrument = {
  __typename: 'MutualFundInstrument',
  symbol: 'AAPL',
  name: 'Apple Inc.',
  description: 'Apple Technology Company',
  priorClosePrice: {
    amount: 123.45,
    currencyCode: 'USD',
  },
  image: 'https://drivewealth.imgix.net/symbols/aapl_1666583960.png?fit=fillmax&w=125&h=125&bg=FFFFFF',
}

export const mockGetInvestmentInstrumentHandler = graphql.query('instrument', () => {
  return HttpResponse.json({ data: { instrument: investmentInstrumentMock } })
})

export const mockInvestmentInstrumentDetail = [mockGetInvestmentInstrumentHandler]
